export const marcSubFields = ['$$Q','$$R','$$V','$$Z'];


// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/constants.ts